// src/components/MyLineChart.styles.ts
import { lighten, Theme } from "@mui/material";
const useStyles = (theme: Theme) => {
  return {
    container: {
      height: "100%",
      width: "100%",
      display: "flex",
      alignItens: "start",
      justifyContent: "start",
      // marginTop: 3,
      gap: 3,
      //paddingX: 3,
      //paddingBottom: 3,
    },
    bar: (
      value: number,
      valueTotal: number,
      color: string,
      orientation?: Orientation
    ) => ({
      ...(orientation === "vertical"
        ? { height: `${(value / valueTotal) * 100}%`, width: "25px" }
        : { width: `${(value / valueTotal) * 100}%`, height: "25px" }),
      background: color || theme.palette.background.default,
      borderRadius: "5px",
      "&:hover": {
        background: lighten(color || theme.palette.background.default, 0.2),
      },
    }),
    icon: (color: string) => ({
      color: color || theme.palette.background.default,
      fontSize: "15px",
    }),
    label: {
      color: theme.palette.text.secondary,
    },
    value: {
      fontSize: "1.3rem",
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
  };
};

export default useStyles;
